// extracted by mini-css-extract-plugin
export default {"about__title":"About_about__title__WItys","about__list":"About_about__list__VeC4N","about__subtitle":"About_about__subtitle__lMcp2","about__text":"About_about__text__0y5C7"};